// extracted by mini-css-extract-plugin
export var active = "_6b-a";
export var activeIndicator = "_6b-9";
export var disabled = "_6b-b";
export var fullWidth = "_6b-2";
export var lg = "_6b-7";
export var md = "_6b-6";
export var redoButtonTabGroup = "_6b-0";
export var sm = "_6b-5";
export var tabButton = "_6b-4";
export var tabButtonsContainer = "_6b-1";
export var themeDestructive = "_6b-d";
export var themeNormal = "_6b-c";
export var themeSuccess = "_6b-e";
export var xl = "_6b-8";
export var xs = "_6b-3";